// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasShellContext, useShellContext } from "@insite/client-framework/Components/IsInShell";
import Zone from "@insite/client-framework/Components/Zone";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import TextSeparator, { TextSeparatorPresentationProps } from "@store/Components/Toolkit/TextSeparator";
import { signInProps } from "@store/Themes/common/props/signIn";
import breakpoint from "@store/Framework/Common/Utilities/breakpoint";
import { useCurrentUserIsGuest, useSettingsCollection } from "@store/Framework/Store/Context/ContextHooks";
import { useReturnUrl } from "@store/Framework/Store/Data/Pages/PageHooks";
import { usePageLinkByPageType } from "@store/Framework/Store/Links/LinksHooks";
import React, { FC } from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasShellContext;

export interface SignInStyles {
    container?: InjectableCss;
    grid?: GridContainerProps;
    signInGridItem?: GridItemProps;
    separatorGridItem?: GridItemProps;
    separator?: TextSeparatorPresentationProps;
    createAndGuestGridItem?: GridItemProps;
    spacerGridItem?: GridItemProps;
}

const signInStyles: SignInStyles = {
    grid: { gap: 0 },
    signInGridItem: { width: [12, 12, 4, 4, 4] },
    separatorGridItem: {
        width: [12, 12, 1, 1, 1],
        css: css`
            justify-content: center;
        `,
    },
    separator: {
        ...signInProps.separator,
        directionBreakpoint: "md",
    },
    createAndGuestGridItem: {
        width: [12, 12, 3, 3, 3],
        css: css`
            ${breakpoint("md")} {
                display: flex;
                align-items: stretch;
                height: auto;
            }
        `,
    },
};

const styles = signInStyles;

const SignInView: FC<Props> = ({ id }) => {
    const { isEditing } = useShellContext();
    const { accountSettings } = useSettingsCollection();
    const allowCreateAccount = accountSettings.allowCreateAccount;
    const allowGuestCheckout = accountSettings.allowGuestCheckout && !useCurrentUserIsGuest();
    const showGuestCheckout = useReturnUrl() === usePageLinkByPageType("CheckoutShippingPage")?.url || isEditing;

    return (
        <StyledWrapper {...styles.container}>
            <GridContainer {...styles.grid}>
                <GridItem {...styles.signInGridItem}>
                    <Zone contentId={id} zoneName="Left" />
                </GridItem>
                {allowCreateAccount && (
                    <>
                        <GridItem {...styles.separatorGridItem}>
                            <TextSeparator {...styles.separator}>{translate("OR")}</TextSeparator>
                        </GridItem>
                        <GridItem {...styles.createAndGuestGridItem}>
                            <Zone contentId={id} zoneName="Middle" />
                        </GridItem>
                    </>
                )}
                {allowGuestCheckout && showGuestCheckout && (
                    <>
                        <GridItem {...styles.separatorGridItem}>
                            <TextSeparator {...styles.separator}>{translate("OR")}</TextSeparator>
                        </GridItem>
                        <GridItem {...styles.createAndGuestGridItem}>
                            <Zone contentId={id} zoneName="Right" />
                        </GridItem>
                    </>
                )}
            </GridContainer>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: SignInView,
    definition: {
        allowedContexts: ["SignInPage"],
        group: "Sign In",
        icon: "table-layout",
    },
};

export default widgetModule;
